export enum RegistrationStep {
    NotSelected = -1,
    GetStarted = 0,
    QuickStart = 1,
    BasicDetails = 5,
    AcceptTransfusions = 10,
    AssessOrganDisease = 15,
    AssessHeartAttack = 20,
    AssessDiabetes = 25,
    AssessCancer = 30,
    AssessKidneyStones = 40,
    PregnantOrNursing = 45,
    AssessTobacco = 50,
    DonationDetails = 55,
    ScreeningComplete = 100,
    HistoryDemographics = 105,
    HistoryDiagnosed = 110,
    HistoryFamily = 115,
    HistoryMisc = 120,
    HistorySocial = 125,
    PreWorkupLabs = 150,
    SelectCenter = 195,
    NkrCenters = 198,
    PendingEmr = 1000,
    AutoRuledOut = 2000,
    ManuallyRuledOut = 2001,
    TempRuleOut = 2002
}